import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MultipleImages, TextFiles } from "@air/next-icons";
import Router from "next/router";
import { memo } from "react";
import { useDispatch } from "react-redux";
import { Routes } from "~/constants/routes";
import { BOARD_COLLECTION_SUCCESS_STATE, BOARD_COLLECTION_SUCCESS_STATE_SIGN_UP, BOARD_COLLECTION_SUCCESS_STATE_UPLOAD_MORE } from "~/constants/testIDs";
import { clearBoardCollectionClipsAction, setAttemptedSubmissionAction, setBoardCollectionViewAction, setHasSubmittedAction, setSessionIdAction } from "~/store/boardCollection/actions";
const CloudOne = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx("svg", {
        className: "w-full",
        viewBox: "0 0 213 107",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M34.9664 81.6166C46.524 79.6744 55.288 69.4638 55.288 57.2554V47.0448C55.288 21.5182 75.7192 0.875 100.861 0.875C126.058 0.875 146.434 21.5737 146.434 47.0448V47.4332C146.434 56.9779 154.048 64.6914 163.469 64.6914H191.624C203.072 64.6914 212.383 74.1251 212.383 85.7231C212.383 97.321 203.072 106.755 191.624 106.755H40.1153H12.8372C5.99031 106.755 0.458008 101.15 0.458008 94.2134C0.458008 87.2769 5.99031 81.6721 12.8372 81.6721H34.9664V81.6166Z",
            fill: "#EFEFEF"
        })
    });
});
CloudOne.displayName = "CloudOne";
const CloudTwo = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx("svg", {
        className: "w-full",
        viewBox: "0 0 319 142",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M319 111.738C319 95.2563 305.625 81.8476 289.185 81.8476H274.138C261.97 81.8476 252.124 71.9774 252.124 59.7792V58.4756C252.124 26.4438 226.21 0.557617 194.351 0.557617C162.399 0.557617 136.577 26.5369 136.577 58.4756C136.577 73.9328 124.038 86.5034 108.619 86.5034H64.9642C57.6264 86.5034 51.6819 92.4628 51.6819 99.819C51.6819 105.871 46.7591 110.9 40.6288 110.9H15.2716C7.00499 110.9 0.317383 117.604 0.317383 125.891V126.357C0.317383 134.83 7.19075 141.814 15.736 141.814H289.185C305.625 141.721 319 128.312 319 111.738Z",
            fill: "#EFEFEF"
        })
    });
});
CloudTwo.displayName = "CloudTwo";
const StarShape = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx("svg", {
        className: "w-full",
        viewBox: "0 0 46 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M42.4339 20.6326L30.6044 18.3718C29.9284 18.1979 29.4214 17.6761 29.4214 16.9805L26.7175 4.28482C26.5485 2.37177 24.8586 0.980469 22.6616 0.980469H22.1547C20.1268 0.980469 18.4368 2.54569 18.2678 4.45873L16.2399 17.3283C16.2399 18.0239 15.7329 18.5457 15.0569 18.7196L3.39635 21.6761C1.70642 22.1979 0.523438 23.7631 0.523438 25.5022V25.6761C0.523438 27.4153 1.87542 28.9805 3.56536 29.3283L15.3949 31.5892C16.0709 31.7631 16.5779 32.2848 16.5779 32.9805L19.2818 45.6761C19.4508 47.5892 21.1407 48.9805 23.3376 48.9805H23.8446C25.8726 48.9805 27.5625 47.4152 27.7315 45.5022L29.7594 32.6326C29.7594 31.937 30.2664 31.4152 30.9423 31.2413L42.6029 28.2848C44.2928 27.7631 45.4758 26.1979 45.4758 24.4587V24.2848C45.4758 22.5457 44.1239 20.9805 42.4339 20.6326Z",
            fill: "#FFA400"
        })
    });
});
StarShape.displayName = "StarShape";
export const BoardCollectionSuccessState = /*#__PURE__*/ memo(()=>{
    const dispatch = useDispatch();
    const onSignUpClick = ()=>{
        Router.push(Routes.auth.signUp);
    };
    const onUploadMoreClick = ()=>{
        dispatch(setBoardCollectionViewAction({
            view: "onboarding"
        }));
        dispatch(setSessionIdAction({
            sessionId: ""
        }));
        dispatch(setHasSubmittedAction({
            hasSubmitted: false
        }));
        dispatch(setAttemptedSubmissionAction({
            attemptedSubmission: false
        }));
        dispatch(clearBoardCollectionClipsAction());
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative h-[calc(100%-72px)] w-full bg-pigeon-25",
        "data-testid": BOARD_COLLECTION_SUCCESS_STATE,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute left-1/2 top-1/2 z-[4] flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-24 font-semibold text-pigeon-700",
                        children: "Hooray! Your content has been submitted."
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mt-4 text-14 text-pigeon-500",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-medium text-jay-500 hover:underline",
                                onClick: onUploadMoreClick,
                                "data-testid": BOARD_COLLECTION_SUCCESS_STATE_UPLOAD_MORE,
                                children: "Upload more,"
                            }),
                            " ",
                            "or",
                            " ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-medium text-jay-500 hover:underline",
                                onClick: onSignUpClick,
                                "data-testid": BOARD_COLLECTION_SUCCESS_STATE_SIGN_UP,
                                children: "sign up for Air"
                            }),
                            " ",
                            "to make your own content collection form."
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TextFiles, {
                        className: "absolute right-9 top-[-65px] size-10 text-peacock-400 opacity-80",
                        style: {
                            transform: "rotate(17.15deg)"
                        }
                    }),
                    /*#__PURE__*/ _jsx(MultipleImages, {
                        className: "absolute bottom-[-55px] left-[-9px] size-10 text-flamingo-200 opacity-80",
                        style: {
                            transform: "rotate(-29.94deg)"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute -right-12 bottom-0 size-4 rounded-full bg-flamingo-200"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute bottom-[-42px] right-[-18px] w-[45px]",
                        children: /*#__PURE__*/ _jsx(StarShape, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute -left-3 -top-12 h-8 w-2.5 rounded-xl bg-canary-300"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute -top-8 left-[-38px] h-9 w-2.5 rotate-[-60deg] rounded-xl bg-macaw-300"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute left-[-42px] top-0 h-8 w-2.5 rotate-[100deg] rounded-xl bg-canary-300"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute bottom-[21%] left-[8%] z-1 w-[163px]",
                children: /*#__PURE__*/ _jsx(CloudTwo, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute bottom-[8%] right-[28%] z-1 w-[302px]",
                children: /*#__PURE__*/ _jsx(CloudOne, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute left-[16%] top-1/4 z-1 w-[211px]",
                children: /*#__PURE__*/ _jsx(CloudOne, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute right-[4.4%] top-[15.3%] z-1 w-[318px]",
                children: /*#__PURE__*/ _jsx(CloudTwo, {})
            })
        ]
    });
});
BoardCollectionSuccessState.displayName = "BoardCollectionSuccessState";
